import { Form, Input, Select, Space, Typography } from "antd";

import FormInput from "../Forms/FormInput";
import { MdOutlineArrowOutward } from "react-icons/md";
import { useForm } from "antd/es/form/Form";
import { formRules, options } from "../../constant";
import { useEffect, useState } from "react";
import PrimaryButton from "../Forms/PrimaryButton";
import { BsAsterisk } from "react-icons/bs";
import { LuAsterisk } from "react-icons/lu";
import OtpModal from "./OtpModal";
import { useApiCall } from "../../services/api";
import { useGlobalModal } from "../../context/SuccessModalProvider";
import { useSelector } from "react-redux";

const { Title } = Typography;

const EditLogin = ({ detail, handleSubmit, loading, routeType }) => {
  const [form] = useForm();
  const { postApi, loading: apiLoading } = useApiCall();
  const { showPopup } = useGlobalModal();
  const [step, setStep] = useState(1);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [verifyOtp, setVerifyOtp] = useState({ email: true, phone: true });
  const { is_admin, user_id } = useSelector((state) => state.auth);

  const sendOtp = async (type, values, showResponse = false) => {
    const data = { [type]: values[type], deviceType: "Web" };
    if (type === "phone") {
      data.email = values.email;
    }

    const apiRoute = `sales/employee/signup-send-otp-${type}`;
    const res = await postApi(apiRoute, data, showResponse);
    return !!res?.status;
  };

  const handleResendOtp = async (type = "email", showResponse = false) => {
    return sendOtp(type, formData, showResponse);
  };

  const validateDuplicateUser = async (values) => {
    const checkExisting = await postApi("user/check-duplicate-user", {
      phone: values.phone,
      email: values.email,
      user_id: detail?.user_id || user_id,
    });

    if (!checkExisting?.status) {
      showPopup({
        title: null,
        content: (
          <span className="custom-modal-title">{checkExisting?.message}</span>
        ),
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
      return false;
    }

    return true;
  };

  const onFinish = async (values) => {
    const emailChanged = (values.email || "") !== (detail?.email?.trim() || "");
    const phoneChanged = (values.phone || "") !== (detail?.phone?.trim() || "");

    const isValid = await validateDuplicateUser(values);
    if (!isValid) return;

    if ((!emailChanged && !phoneChanged) || routeType !== "user") {
      handleSubmit(values);
      return;
    }

    setFormData(values);
    setVerifyOtp({ email: emailChanged, phone: phoneChanged });

    const sentEmail = emailChanged ? await sendOtp("email", values) : true;
    const sentPhone = phoneChanged ? await sendOtp("phone", values) : true;

    if (!sentEmail || !sentPhone) {
      showPopup({
        title: null,
        content: (
          <span className="custom-modal-title">
            Failed to send OTP to the provided {!sentEmail ? "email" : ""}
            {!sentPhone ? (!sentEmail ? " and phone" : "phone") : ""}.
          </span>
        ),
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
      return;
    }

    showPopup({
      title: null,
      content: (
        <span className="custom-modal-title">
          Please enter the OTP sent to the provided{" "}
          {emailChanged && phoneChanged
            ? "email and phone"
            : emailChanged
              ? "email"
              : "phone"}
          .
        </span>
      ),
      onOk: () => {
        setStep((prev) => prev + 1);
        setShowOtpModal(true);
      },
      className: "custom-success-modal",
    });
  };

  useEffect(() => {
    if (detail) {
      form.setFieldsValue({
        email: detail.email || "",
        phone: detail.phone || "",
      });
    }
  }, [detail, form]);

  if (showOtpModal) {
    return (
      <OtpModal
        formType="Employee"
        step={step}
        formData={formData}
        handleResendOtp={handleResendOtp}
        handleFinish={async () => {
          const res = await handleSubmit(formData);
          if (res) {
            setShowOtpModal(false);
          }
        }}
        title={"OTP Verification"}
        verifyEmailOtp={verifyOtp.email}
        verifyPhoneOtp={verifyOtp.phone}
        onPrevious={() => {
          setStep((prev) => prev - 1);
          setShowOtpModal(false);
        }}
        isOwnProfile={routeType == "user"}
      />
    );
  }

  return (
    <>
      <Title level={2} className="w-full text-left font-abhaya">
        Edit Login Details
      </Title>
      <Form
        name="trigger"
        layout="vertical"
        autoComplete="off"
        form={form}
        onFinish={onFinish}
      >
        <FormInput
          className="mb-0 h-[47.6px]"
          label={"Email Address"}
          name={"email"}
          rules={formRules.email}
        />
        <label className="flex items-center">
          <span className="text-red-400">
            <LuAsterisk />
          </span>
          Phone No.
        </label>
        <Space.Compact style={{ width: "100%" }} size="large" className="mt-2">
          <Form.Item
            name="phone_code"
            style={{
              width: "30%",
              borderRadius: "20px",
              paddingRight: "10px",
            }}
            className="phone-css"
          >
            <Select
              placeholder="Code"
              options={options}
              defaultValue={"+91"}
              style={{
                width: "100%",
                height: "47.6px",
              }}
            />
          </Form.Item>

          <Form.Item
            name="phone"
            style={{ width: "100%" }}
            rules={formRules.phone}
          >
            <Input
              placeholder="Enter phone number"
              style={{ width: "100%", padding: "12px", height: "47.6px" }}
              maxLength={10}
            />
          </Form.Item>
        </Space.Compact>

        <div className="w-full flex justify-center">
          <PrimaryButton
            className="me-[30px]"
            text={"Save and Proceed"}
            onClick={() => form.submit()}
            loading={loading || apiLoading}
          />
        </div>
      </Form>
    </>
  );
};

export default EditLogin;
